// Months array for date formatting
const months: Array<string> = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];

// Character limit for suggestion api
const suggestionApiQueryMaxlength: number = 70;

// Character limit for job search api
const jobSearchQueryMaxlength: number = 40;

export { months, jobSearchQueryMaxlength, suggestionApiQueryMaxlength };

export const ROLE_TYPES = Object.freeze({
    UNAUTH: 'UNAUTH',
    USER_DEFAULT: 'USER_DEFAULT',
    USER_CONTRIBUTOR: 'USER_CONTRIBUTOR',
    USER_ADMIN: 'USER_ADMIN',
    EMPLOYER_DEFAULT: 'EMPLOYER_DEFAULT',
    EMPLOYER_RECRUITER: 'EMPLOYER_RECRUITER',
    EMPLOYER_ADMIN: 'EMPLOYER_ADMIN',
});

export const PAGE_DISPLAY_MODE = Object.freeze({
    USER_DEFAULT: 'USER_DEFAULT',
    EMPLOYER_DEFAULT: 'EMPLOYER_DEFAULT',
});

export const EMPLOYER_ROLES = Object.freeze({
    admin: 'admin',
    recruiter: 'recruiter',
    employee: 'employee',
    reviewer: 'reviewer',
});

export const DOMAINS = ['fairygodboss.com', 'themuse.com', 'fairygodboss.info'];
